export default (tracker) => ({
  async seen(data) {
    await tracker.track('Tariffs Modal Seen', data)
  },

  async closed(data) {
    await tracker.track('Tariffs Modal Closed', data)
  },

  async submittedEmail(data) {
    await tracker.track('Tarrifs Modal Email Submitted', data)
  },
})
